import React, { useState } from 'react';

const EmojiSprite = ({ children }) => {
	return <span className="EmojiSprite">{children}</span>;
};

export default EmojiSprite;
